import {z} from "zod/v4-mini"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"

export const stringLikeMarker = Symbol("StringLike")

export interface StringLikeNode extends FundamentalLikeNode<string | null> {
    readonly [stringLikeMarker]: true
}

export const stringMarker = createFundamentalMarker<StringLikeNode, string>(stringLikeMarker, {
    rawSchema: z.string(),
    acceptsRaw: (x): x is string => typeof x === "string",
})
export const {
    isLikeNode: isStringLikeNode,
    isLikeNodeClass: isStringLikeNodeClass,
    likeNode: stringLikeNode,
    isLike: isStringLike,
    like: stringLike,
} = stringMarker
export type StringLike = z.infer<typeof stringLike>
